import React from "react";
import { CloudUpload } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import {
  useGetAccommodationFilesQuery,
  GetAccommodationFiles,
  AccommodationEventLog_GetEvents,
  useDeleteAccommodationDocMutation
} from "@graphql";
import { SecondaryButton } from "@components";
import DocumentList from "@containers/DocumentList/DocumentList";

type Props = {
  id: string;
  onUpload: () => void;
};

export function AccommodationDocuments({ id, onUpload }: Props) {
  const { data, loading } = useGetAccommodationFilesQuery({
    variables: {
      id
    }
  });
  const [deleteDoc] = useDeleteAccommodationDocMutation();
  const handleDelete = (doc) => {
    deleteDoc({
      variables: {
        id: data.accommodation._id,
        fileId: doc.FileRef.NodeID
      },
      refetchQueries: [
        GetAccommodationFiles.OperationName,
        AccommodationEventLog_GetEvents.OperationName
      ]
    });
  };

  return (
    <div>
      <div style={{ display: "flex", marginBottom: 16 }}>
        <SecondaryButton
          onClick={onUpload}
          variant="outlined"
          leftIcon={<CloudUpload />}
          style={{ marginLeft: "auto" }}
        >
          {locale.UploadFile}
        </SecondaryButton>
      </div>

      <DocumentList
        loading={loading}
        groupBy={(d) => locale.accommodationDocumentType[d.DocumentType]}
        documents={data?.accommodation.documents || []}
        onDelete={handleDelete}
      />
    </div>
  );
}
